module.exports = __webpack_public_path__ + "img/eh.2a0e164e.svg";